import { Row, Col, Card, Avatar, Typography, Button } from "antd";
import { testimonialMainImage, testimonialQuotes } from "../../../assets";
import { useMediaQuery } from "react-responsive";
import { ArrowLeftOutlined, ArrowRightOutlined, StarFilled } from "@ant-design/icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";
import { getStrapiMedia } from "../../../helpers/tranformers";

const Testimonials = ({ content }) => {
  const { Title, Text } = Typography;
  const isMobile = useMediaQuery({ query: "(max-width: 769px)" });
  const [swiperRef, setSwiperRef] = useState(null);
  const [selectedTestimonialIndex, setSelectedTestimonialIndex] = useState(0);

  const prevHandler = () => {
    swiperRef.slidePrev();
  };

  const nextHandler = () => {
    swiperRef.slideNext();
  };

  const orbitProfiles = (content?.Card || []).slice(0, 3);
  const selectedTestimonial = content?.Card?.[selectedTestimonialIndex] || content?.Card?.[1];

  return (
    <div className="work-process-background">
      <div className="section-content mobile-padding-all">
        <Row align={"top"} justify={"center"}>
          <Col
            md={15}
            className="hide-on-mobile"
            style={{ paddingTop: "150px" }}
            data-aos="fade-right"
            data-aos-duration="700"
            data-aos-delay="100"
          >
            <div className="testimonial-visual-wrap">
              <div className="testimonial-main-image-shell">
                <img
                  src={testimonialMainImage}
                  alt="Happy Clients"
                  className="happy-client-imgg"
                />
              </div>
              <div className="testimonial-orbit-ring" />
              {orbitProfiles.map((item, index) => (
                <button
                  key={item?.id || `${item?.Name}-${index}`}
                  type="button"
                  className={`orbit-avatar orbit-avatar-${index + 1} ${
                    selectedTestimonialIndex === index ? "active" : ""
                  }`}
                  aria-label={item?.Name || `Client ${index + 1}`}
                  onClick={() => setSelectedTestimonialIndex(index)}
                >
                  <img
                    src={getStrapiMedia(item?.ProfileImage?.url)}
                    alt={item?.Name || "Client profile"}
                  />
                </button>
              ))}
            </div>
          </Col>
          <Col
            lg={9}
            md={12}
            sm={12}
            data-aos="fade-left"
            data-aos-duration="700"
            data-aos-delay="100"
          >
            <div className="about-section-heading">{content?.Heading}</div>
            <div className="section-heading" style={{ marginBottom: "30px" }}>
              {content?.Title}
            </div>
            <div className="card-content-text" style={{ marginBottom: "30px" }}>
              {content?.Description}
            </div>
            {isMobile ? (
              <div>
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  centeredSlides={true}
                  onSwiper={(swiper) => setSwiperRef(swiper)}
                >
                  {content?.Card?.map((testimonial, index) => {
                    return (
                      <SwiperSlide key={index}>
                        {" "}
                        <Card className="testimonial-card">
                          <div className="testimonial-header-section">
                            <Avatar
                              size={80}
                              className="testimonial-avatar"
                              src={getStrapiMedia(
                                testimonial?.ProfileImage?.url
                              )}
                            />
                            <div className="testimonial-user-info">
                              <Title
                                level={5}
                                className="testimonial-user-name"
                                style={{ marginBottom: "0px" }}
                              >
                                {testimonial?.Name}
                              </Title>
                              <Text className="testimonial-user-designation">
                                {testimonial?.Designation}
                              </Text>
                              <div className="testimonial-rating">
                                {[...Array(testimonial?.Rating)].map(
                                  (_, index) => (
                                    <StarFilled
                                      key={index}
                                      className="testimonial-star-icon"
                                    />
                                  )
                                )}
                              </div>
                            </div>
                            {/* <Quote className="testimonial-quote-icon" /> */}
                            <img
                              src={testimonialQuotes}
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "10px",
                                height: "auto",
                                width: "40px",
                              }}
                            />
                          </div>

                          <Text className="testimonial-text">
                            {testimonial?.Review[0]?.children[0]?.text}
                          </Text>
                        </Card>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>

                <div className="swiper-controls">
                  <Button
                    variant="outlined"
                    className="slider-button-prev"
                    onClick={prevHandler}
                  >
                    <ArrowLeftOutlined />
                  </Button>
                  <Button
                    variant="outlined"
                    type=""
                    className="slider-button-next"
                    onClick={nextHandler}
                  >
                    <ArrowRightOutlined />
                  </Button>
                </div>
              </div>
            ) : (
              <Card
                key={selectedTestimonialIndex}
                className="testimonial-card"
                data-aos="fade-up"
                data-aos-duration="350"
                data-aos-easing="ease-out"
              >
                <div className="testimonial-header-section">
                  <Avatar
                    size={80}
                    className="testimonial-avatar"
                    src={getStrapiMedia(selectedTestimonial?.ProfileImage?.url)}
                  />
                  <div className="testimonial-user-info">
                    <Title
                      level={5}
                      className="testimonial-user-name"
                      style={{ marginBottom: "0px" }}
                    >
                      {selectedTestimonial?.Name}
                    </Title>
                    <Text className="testimonial-user-designation">
                      {selectedTestimonial?.Designation}
                    </Text>
                    <div className="testimonial-rating">
                      {[...Array(selectedTestimonial?.Rating || 0)].map((_, index) => (
                        <StarFilled
                          key={index}
                          className="testimonial-star-icon"
                        />
                      ))}
                    </div>
                  </div>
                  {/* <Quote className="testimonial-quote-icon" /> */}
                  <img
                    src={testimonialQuotes}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "10px",
                      height: "auto",
                      width: "40px",
                    }}
                  />
                </div>

                <Text className="testimonial-text">
                  {selectedTestimonial?.Review?.[0]?.children?.[0]?.text}
                </Text>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Testimonials;
